import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_message_wrap = _resolveComponent("message-wrap")!

  return (_openBlock(), _createBlock(_component_message_wrap, {
    isShowMessageTail: _ctx.isShowMessageTail,
    avatar: _ctx.avatar
  }, {
    default: _withCtx(() => _cache[0] || (_cache[0] = [
      _createElementVNode("div", { class: "animation" }, [
        _createElementVNode("span", { class: "circle-1 circle" }),
        _createElementVNode("span", { class: "circle-2 circle" }),
        _createElementVNode("span", { class: "circle-1 circle" })
      ], -1)
    ])),
    _: 1
  }, 8, ["isShowMessageTail", "avatar"]))
}